import { createSlotRecipe } from './runtime';

const treeViewConfig = {"name":"treeView","slots":["root","label","tree","item","itemIndicator","itemText","branch","branchControl","branchTrigger","branchContent","branchText","branchIndicator","branchIndentGuide"]}

export const treeView = /* @__PURE__ */ createSlotRecipe(treeViewConfig)